/**
 * @file 带图的卡片
 * @author FengGuang(fengguang01@baidu.com)
 *
 */

import React, {useEffect, useRef, useState} from 'react';

export interface IHorizontalPictureCard {
    title: string;
    text: string;
    imageUrl: string;
}

interface IProps extends IHorizontalPictureCard {
    children?: React.ReactNode;
}

const HorizontalPictureTextCard: React.FC<IProps> = props => {
    const [showEllipsis, setShowEllipsis] = useState<boolean>(false);
    const textRef = useRef<HTMLDivElement>(null);
    const textInnerRef = useRef<HTMLDivElement>(null);

    const {
        title,
        text,
        imageUrl
    } = props;

    // 检查是否需要显示省略号，如果需要则会触发重新渲染
    useEffect(() => {
        if (textRef.current && textInnerRef.current) {
            const textHeight = textRef.current.getBoundingClientRect().height;
            const textInnerHeight = textInnerRef.current.getBoundingClientRect().height;
            const newShowEllipsis = textHeight < textInnerHeight;
            if (showEllipsis !== newShowEllipsis) {
                setShowEllipsis(newShowEllipsis);
            }
        }
    }, [text, showEllipsis, setShowEllipsis]);

    // 监听窗口大小变化事件，调整是否显示省略号
    useEffect(() => {
        // didMount
        const resizeMethod = () => {
            if (textRef.current && textInnerRef.current) {
                const textHeight = textRef.current.getBoundingClientRect().height;
                const textInnerHeight = textInnerRef.current.getBoundingClientRect().height;
                const newShowEllipsis = textHeight < textInnerHeight;
                if (showEllipsis !== newShowEllipsis) {
                    setShowEllipsis(newShowEllipsis);
                }
            }
        };
        window.addEventListener('resize', resizeMethod);
        // willUnmount
        return () => {
            window.removeEventListener('resize', resizeMethod);
        };
    }, [showEllipsis]);

    return (
        <div className="paddle-horizontal-picture-text-card">
            <div
                className="paddle-horizontal-picture-text-card-img"
                style={{backgroundImage: `url(${imageUrl})`}}
            >
                <img alt={title} src={imageUrl} />
            </div>
            <div className="paddle-horizontal-picture-text-card-contain">
                <div className="paddle-horizontal-picture-text-card-contain-inner">
                    <div className="paddle-horizontal-picture-text-card-title">
                        {title}
                    </div>
                    <div className="paddle-horizontal-picture-text-card-text-wrap">
                        <div className="paddle-horizontal-picture-text-card-text" ref={textRef}>
                            <div className="paddle-horizontal-picture-text-card-text-inner" ref={textInnerRef}>
                                {text}
                            </div>
                        </div>
                        {
                            !!showEllipsis
                            && <div className="paddle-horizontal-picture-text-card-text-ellipsis">...</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HorizontalPictureTextCard;
